import {
  useState,
  useEffect,
} from "react";

import {
  Card,
  Row,
  Col,
  Typography,
  Button,
  Space,
  Divider,
  Empty,
  DatePicker,
  Tag,
  Input,
  Select,
  InputNumber,
} from "antd";

import {
  DeleteOutlined,
  PlusOutlined,
  HomeOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";

import dayjs from "dayjs";

import {
  searchHotels,
} from "../../../services/quotationService";

import HotelCard
  from "./hotels/HotelCard";

import TransportCard
  from "./TransportCard";
import LineItemSection
  from "./LineItemSection";

const { Title, Text } = Typography;

const DayCard = ({
  lead,
  day,
  dayNumber,
  removeDay,
  updateDay,
  globalTransportConfig,
  vehicleOptions = [],
  onOpenActivitySearch,
  searchHotels,
}) => {

  /* =====================================================
     HOTEL SEARCH
  ===================================================== */

  const [
    hotelSearch,
    setHotelSearch,
  ] = useState("");

  const [
    hotelResults,
    setHotelResults,
  ] = useState([]);

  /* =====================================================
     LOAD HOTELS
  ===================================================== */

  useEffect(() => {

    const loadHotels = async () => {

      if (!hotelSearch?.trim()) {

        setHotelResults([]);

        return;
      }

      try {

        const destParam = Array.isArray(lead?.destinations) && lead.destinations.length
          ? lead.destinations.map(d => d.name || d.city || d).join(",")
          : (lead?.destination?.name || lead?.destination?.city || lead?.destination || "");

        const response =
          await searchHotels(
            hotelSearch,
            day.date,
            lead?._id || null,
            destParam
          );

        setHotelResults(

          Array.isArray(
            response?.data?.data
          )

            ? response.data.data

            : []

        );

      } catch (error) {

        console.error(
          "HOTEL SEARCH ERROR:",
          error
        );
      }
    };

    const timer =
      setTimeout(
        loadHotels,
        400
      );

    return () =>
      clearTimeout(timer);

  }, [
    hotelSearch,
    day.date,
  ]);

  /* =====================================================
     ADD EMPTY HOTEL
  ===================================================== */

  const addHotel = () => {

    const updatedHotels = [

      ...(day.hotels || []),

      {

        hotelId: "",

        name: "",

        city: "",

        image: "",

        roomOptions: [],

        mealOptions: [],

        roomType: "",

        mealPlan: "",

        nights: 1,

        occupancy: {

          adults: 2,

          extraAdults: 0,

          cwb: 0,

          cnb: 0,
        },

        basePrice: 0,

        extraAdultPrice: 0,

        cwbPrice: 0,

        cnbPrice: 0,

        total: 0,
      },
    ];

    updateDay(day.id, {

      hotels:
        updatedHotels,
    });
  };

  /* =====================================================
     ADD EMPTY ACTIVITY
  ===================================================== */

  const addActivity = () => {

    const updatedActivities = [

      ...(day.activities || []),

      {

        title: "",

        category:
          "Sightseeing",

        quantity: 1,

        price: 0,

        total: 0,

        notes: "",
      },
    ];

    updateDay(day.id, {

      activities:
        updatedActivities,
    });
  };

  return (

    <Card
      style={{

        borderRadius: 22,

        marginBottom: 24,

        border:
          "1px solid #e8edf5",

        overflow:
          "hidden",

        background:
          "#ffffff",

        boxShadow:
          "0 14px 40px rgba(15,23,42,0.08)",
      }}

      bodyStyle={{
        padding: 24,
      }}
    >

      {/* =====================================================
         HEADER
      ===================================================== */}

      <Row
        justify="space-between"
        align="top"
      >

        <Col span={20}>

          <Space
            direction="vertical"
            size={14}
            style={{
              width: "100%",
            }}
          >

            {/* =========================================
                DAY TITLE
            ========================================= */}

            <Space
              align="center"
              wrap
            >

<div
  style={{

    background:
      "linear-gradient(135deg,#2563eb,#7c3aed)",

    color: "#fff",

    borderRadius: 999,

    padding: "8px 18px",

    fontSize: 13,

    fontWeight: 800,

    letterSpacing: 1,

    boxShadow:
      "0 8px 18px rgba(37,99,235,0.25)",
  }}
>
  DAY {dayNumber}
</div>

<Title
  level={3}
  style={{
    margin: 0,

    fontWeight: 800,

    color: "#0f172a",
  }}
>

                {
                  day.title ||

                  `Day ${dayNumber}`
                }
              </Title>

            </Space>

            {/* =========================================
                DATE
            ========================================= */}

            <DatePicker

style={{

  width: "100%",
  maxWidth: 280,

  borderRadius: 14,

  height: 46,
}}

              placeholder="Travel Date"

              suffixIcon={
                <CalendarOutlined />
              }

              value={
                day.date

                  ? dayjs(day.date)

                  : null
              }

              onChange={(date) =>

                updateDay(day.id, {

                  date:
                    date?.format(
                      "YYYY-MM-DD"
                    ),
                })

              }
            />

          </Space>

        </Col>

        {/* =============================================
            REMOVE BUTTON
        ============================================= */}

        <Col>

          <Button
            danger

            icon={
              <DeleteOutlined />
            }

            onClick={() =>
              removeDay(day.id)
            }
          >
            Remove
          </Button>

        </Col>

      </Row>

      {/* =====================================================
         TRANSPORT FIRST (SEMBARK FLOW)
      ===================================================== */}

      <Divider />

      <TransportCard
        lead={lead}
        day={day}
        updateDay={updateDay}
        globalTransportConfig={
          globalTransportConfig
        }
        vehicleOptions={vehicleOptions}
      />

      {/* =====================================================
         HOTELS
      ===================================================== */}

      <Divider />

      <Row
        justify="space-between"
        align="middle"
        style={{
          marginBottom: 18,
        }}
      >

        <Col>

          <Space>

            <HomeOutlined
              style={{
                color: "#1677ff",
              }}
            />

<Text
  strong
  style={{

    fontSize: 18,

    fontWeight: 800,

    color: "#0f172a",
  }}
>
  Hotels & Stay
</Text>

          </Space>

        </Col>

        <Col>

          <Button
            type="primary"
            ghost

            icon={
              <PlusOutlined />
            }

            onClick={
              addHotel
            }
          >
            Add Hotel
          </Button>

        </Col>

      </Row>

      {(day.hotels || []).length ? (

        day.hotels.map(
          (
            hotel,
            index
          ) => (

<HotelCard
  key={index}

  lead={lead}

  hotel={hotel}

  index={index}

  day={day}

  updateDay={
    updateDay
  }

  hotelSearch={
    hotelSearch
  }

  setHotelSearch={
    setHotelSearch
  }

  hotelResults={
    hotelResults
  }

  setHotelResults={
    setHotelResults
  }

  searchHotels={
    searchHotels
  }
/>

          )
        )

      ) : (

        <Card
          size="small"
          style={{

            borderRadius: 14,

            border:
              "1px dashed #d1d5db",

            background:
              "linear-gradient(135deg,#ffffff 0%,#f8fbff 100%)",
          }}
        >

          <Empty
            image={
              Empty.PRESENTED_IMAGE_SIMPLE
            }

            description="No hotels added"
          />

        </Card>

)}

      {/* =====================================================
         ACTIVITIES
      ===================================================== */}

      <Divider />

      <LineItemSection
        title="Sightseeing & Experiences"

        buttonText="Add Activity"

        field="activities"

        items={
          day.activities || []
        }

        day={day}

        updateDay={
          updateDay
        }

        color="#722ed1"
        onSearchCatalog={onOpenActivitySearch}
      />

      {/* =====================================================
         OTHER INCLUSIONS
      ===================================================== */}

      <Divider />

      <LineItemSection
        title="Other Inclusions"

        buttonText="Add Inclusion"

        field="specialInclusions"

        items={
          day.specialInclusions || []
        }

        day={day}

        updateDay={
          updateDay
        }

        color="#1677ff"
      />


    </Card>
  );
};

export default DayCard;

